/* eslint-disable array-callback-return */
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import AntSwitch from './AntSwitch';
import DialogTitle from '@material-ui/core/DialogTitle';
import Hidden from '@material-ui/core/Hidden';
// import AvailabilityFilterForModals from './AvailabilityFilterForModals/AvailabilityFilterForModals';
import RBIAutocomplete from '../RBIAutocomplete/RBIAutocomplete';
// import ChipInput from 'material-ui-chip-input';
import {
  clearEntityToEdit,
  editEquipment,
  getEquipmentHoldingProfile,
  getEquipmentHoldingProfiles,
  getHoldingProfilesEquipmentAssigned,
} from '../../redux/actions/equipmentsActions';
//  import { getRegions, getCountries, getStates } from '../../redux/actions/regionsActions';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { getAllEntitiesCatalog as getCategories } from '../../redux/actions/categoriesActions';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import styles from './styles';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import DividerWithText from '../DividerWithText/DividerWithText';
import VerticalTabsEquipmentAssigned from './VerticalTabsEquipmentAssigned';
import { ShowHoldingProfileEquipment } from './ShowHoldingProfileEquipment';
import { TabPanel } from '../ProfilesTabs/TabPanel';
import { isEmptyObject } from '../../utils/utils';

import {
  EquipmentAvailabilitySelector,
  GetValuesFromAvailability as GetAvailabilityValuesFromPayload,
  ParseRequestAvailabilities as ParseAvailabilityPayload,
} from './EquipmentAvailabilitySelector';
import {
  EquipmentFranchiseGroupsSelector,
  GetValuesFromPayload as GetFranchiseGroupsAvailabilityValuesFromPayload,
  ParseRequestAvailabilities as ParseFranchiseGroupsAvailabilityPayload,
} from './EquipmentFranchiseGroupsSelector';
import {
  groupAvailabilities,
  wrapEquipmentAvailabilities,
} from '../../utils/helpers';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from './../../utils/utils';

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  fr,
  enUS,
  ar,
  cs,
  da,
  de,
  es,
  zhCN,
  nl,
  id,
  it,
  ja,
  ko,
  pt,
  ru,
  sv,
  th,
  tr,
  zhTW,
  fi,
} from 'date-fns/locale';
import { parseISO } from 'date-fns';
import { formatYYYYMMDD } from '../../utils/utils';
import moment from 'moment';
import {
  formatDate,
  getExpiryTerm,
  getWarrantyInformation,
  isPurchaseDateBeforeExpiryDate,
} from '../RestaurantDetailsTabs/EquipmentTabRestaurant/helpers/equipmentWarranty';

export const localesMap = {
  frc: fr,
  fre: fr,
  eng: enUS,
  ara: ar,
  cze: cs,
  dan: da,
  ger: de,
  spa: es,
  spl: es,
  chs: zhCN,
  dut: nl,
  ind: id,
  fil: fi,
  ita: it,
  jpn: ja,
  kor: ko,
  ptb: pt,
  rus: ru,
  swe: sv,
  tai: th,
  tur: tr,
  cht: zhTW,
};

interface IEEMProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

function EditEquipmentModal({
  open,
  setOpen,
  readOnly = false,
  showEquipmentTranslation = (equipmentId: any) => () => {
    // No-op: Default implementation
  },
  onSave = () => {
    // No-op: Default implementation
  },
}) {
  //TODO: calibration check switch and layout
  //TODO: calibration check is not being sent to backend
  const dispatch: any = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      dispatch(clearEntityToEdit());
    };
  }, [dispatch]);
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  // Fetch categories without supplier when modal opens
  useEffect(() => {
    if (open && selectedBrand) {
      dispatch(
        getCategories(
          {
            brand: selectedBrand,
            paginated: 1,
            status: 1,
            limit: 100,
          },
          {
            _disableRequestStatus: true,
          },
        ),
      );
    }
  }, [open, selectedBrand, dispatch]);

  const selectedLanguage = localStorage.getItem('selectedLanguage') || 'eng';

  const classes = styles();
  const handleClose = () => {
    setOpen(false);
  };

  const [tabValue, setTabValue] = React.useState(0);
  //pulling entity from redux
  const cProfiles = useSelector(
    (state: RootStateOrAny) => state.CalibrationProfilesReducer.entities,
  );
  const categories = useSelector(
    (state: RootStateOrAny) => state.CategoriesReducer.entitiesCatalog,
  );
  const manufacturers = useSelector(
    (state: RootStateOrAny) => state.ManufacturersReducer.entitiesCatalog,
  );
  const approvalTypes = useSelector(
    (state: RootStateOrAny) => state.ApprovalTypesReducer.entities,
  );
  const entityToEdit = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.entityToEdit,
  );
  const profiles = useSelector(
    (state: RootStateOrAny) =>
      state.EquipmentsReducer.equipmentsHoldingProfiles,
  );
  const holdingProfilesToAdd = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.equipmentHoldingProfiles,
  );
  //
  const [profilesCopy, setProfilesCopy] = useState<any[]>([]);

  //#region Equipment Availability

  const [availabilityAllowance, setAvailabilityAllowance] = useState<any[]>([]);
  const [availabilityExclusions, setAvailabilityExclusions] = useState<any[]>(
    [],
  );
  const [availabilityFranchiseGroups, setAvailabilityFranchiseGroups] =
    useState<any[]>([]);

  useEffect(() => {
    const values = entityToEdit?.equipment_availabilities || [];
    const [availabilities, exclusions] =
      GetAvailabilityValuesFromPayload(values);

    setAvailabilityAllowance(availabilities);
    setAvailabilityExclusions(exclusions);
  }, [entityToEdit.equipment_availabilities]);

  useEffect(() => {
    if (entityToEdit?.brand) {
      const values = entityToEdit.equipment_franchise_groups || [];
      const availabilities = GetFranchiseGroupsAvailabilityValuesFromPayload(
        entityToEdit.brand,
        values,
      );
      setAvailabilityFranchiseGroups(availabilities);
    }
  }, [entityToEdit.brand, entityToEdit.equipment_franchise_groups]);

  interface MutableObject {
    id: number;
    brand_id?: string;
    region_id?: string;
    category_id?: any;
    manufacturer?: any;
    approval_type_id?: number;
    is_core?: boolean;
    requires_training?: boolean;
    description?: string;
    model?: string;
    is_visible_for_franchise?: boolean;
    is_active?: boolean;
    calibration_profiles?: any;
    equipment_availabilities: any[any];
    availability_exceptions?: any[];
    availability_franchise_groups?: any[];
    equipment_serial_number?: string;
    equipment_date_of_purchase?: any;
    equipment_expiry_term?: string;
    equipment_date_of_expiry?: any;
    equipment_expiry_term_year: number | null;
    equipment_expiry_term_month: number | null;
    equipment_expiry_term_day: number | null;
  }

  const [mutableObject, setMutableObject] = useState<MutableObject>({
    id: -1,
    brand_id: '',
    region_id: '',
    category_id: {},
    manufacturer: {},
    approval_type_id: 0,
    is_core: false,
    requires_training: false,
    description: '',
    model: '',
    is_visible_for_franchise: false,
    is_active: false,
    calibration_profiles: [],
    equipment_availabilities: [],
    equipment_serial_number: '',
    equipment_date_of_purchase: null,
    equipment_expiry_term: '',
    equipment_date_of_expiry: null,
    equipment_expiry_term_year: null,
    equipment_expiry_term_month: null,
    equipment_expiry_term_day: null,
  });

  const handleAvailabilityAllowanceChange = (value: any[]) => {
    setAvailabilityAllowance(value);
    setMutableObject({
      ...mutableObject,
      equipment_availabilities: value.map(({ metas }) => ({
        region_id: metas.regionId,
        country_id: metas.countryId,
        state_id: metas.stateId,
      })),
    });
  };

  const handleAvailabilityExclusionsChange = (value: any[]) => {
    setAvailabilityExclusions(value);
    setMutableObject({
      ...mutableObject,
      availability_exceptions: value.map(({ metas }) => ({
        region_id: metas.regionId,
        country_id: metas.countryId,
        state_id: metas.stateId,
      })),
    });
  };

  const handleFranchiseGroupsChange = (value: any[]) => {
    setAvailabilityFranchiseGroups(value);
    setMutableObject({
      ...mutableObject,
      availability_franchise_groups: value.map(({ metas }) => ({
        id: metas.groupId,
        name: metas.groupName,
      })),
    });
  };

  //#endregion Equipment Availability

  function getCategoryValue(value) {
    const categoryId = value;
    categoryId.name = t(
      `equipment.categories.${textToSnakeCase(categoryId.name)}`,
      categoryId.name,
    );
    return categoryId;
  }

  const [inmutableObject, setInmutableObject] = useState<MutableObject>({
    id: entityToEdit?.id,
    brand_id: entityToEdit?.brand,
    region_id: entityToEdit?.region,
    category_id: getCategoryValue(entityToEdit?.equipment_category),
    manufacturer: entityToEdit?.manufacturer,
    approval_type_id: entityToEdit?.approval_type?.id,
    is_core: entityToEdit?.is_core,
    requires_training: entityToEdit?.requires_training,
    description: entityToEdit?.description,
    model: entityToEdit?.model,
    is_visible_for_franchise: entityToEdit?.is_visible_for_franchise,
    is_active: entityToEdit?.is_active,
    calibration_profiles: entityToEdit.calibration_profiles?.map(
      profile => profile.calibration_profile,
    ),
    equipment_availabilities: [],
    equipment_serial_number: entityToEdit?.equipment_serial_number,
    equipment_date_of_purchase:
      entityToEdit?.equipment_date_of_purchase || null,
    equipment_date_of_expiry: entityToEdit?.equipment_date_of_expiry || null,
    ...getExpiryTerm(
      entityToEdit?.equipment_date_of_purchase,
      entityToEdit?.equipment_date_of_expiry,
    ),
  });
  const [calibrationCheckActive, setCalibrationCheckActive] = useState(false);
  const [selectedProfiles, setSelectedProfiles] = useState<
    { id: number; name: string }[]
  >([]);
  const handleCalibrationFieldActivation = e => {
    setCalibrationCheckActive(!calibrationCheckActive);
    setMutableObject({ ...mutableObject, calibration_profiles: [] });
    setSelectedProfiles([]);
  };

  useEffect(() => {
    setInmutableObject({
      id: entityToEdit?.id,
      brand_id: entityToEdit?.brand,
      region_id: entityToEdit?.region,
      category_id: entityToEdit?.equipment_category,
      manufacturer: entityToEdit?.manufacturer,
      approval_type_id: entityToEdit?.approval_type?.id,
      is_core: entityToEdit?.is_core,
      requires_training: entityToEdit?.requires_training,
      description: entityToEdit?.description,
      model: entityToEdit?.model,
      is_visible_for_franchise: entityToEdit?.is_visible_for_franchise,
      is_active: entityToEdit?.is_active,
      calibration_profiles: entityToEdit.calibration_profiles,
      equipment_availabilities: entityToEdit?.equipment_availabilities
        ?.filter(item => item.is_exclusion === 0)
        .map(({ region_id, country_id, state_id }) => ({
          region_id,
          country_id,
          state_id,
        })),
      availability_exceptions: entityToEdit?.equipment_availabilities
        ?.filter(item => item.is_exclusion === 1)
        .map(({ region_id, country_id, state_id }) => ({
          region_id,
          country_id,
          state_id,
        })),
      availability_franchise_groups:
        entityToEdit?.equipment_franchise_groups?.map(item => ({
          id: item.franchise_group_id,
          name: item.franchise_name,
        })),
      equipment_serial_number: entityToEdit?.equipment_serial_number,
      equipment_date_of_purchase:
        entityToEdit?.equipment_date_of_purchase || null,
      equipment_date_of_expiry: entityToEdit?.equipment_date_of_expiry || null,
      ...getExpiryTerm(
        entityToEdit?.equipment_date_of_purchase,
        entityToEdit?.equipment_date_of_expiry,
      ),
    });

    dispatch(getHoldingProfilesEquipmentAssigned(entityToEdit?.id));
  }, [entityToEdit]);

  useEffect(() => {
    setProfilesCopy(profiles.map(p => p));
  }, [profiles]);

  useEffect(() => {
    setMutableObject({
      id: entityToEdit?.id,
      brand_id: entityToEdit?.brand,
      region_id: entityToEdit?.region,
      category_id: entityToEdit?.equipment_category,
      manufacturer: entityToEdit?.manufacturer,
      approval_type_id: entityToEdit?.approval_type?.id,
      is_core: entityToEdit?.is_core,
      requires_training: entityToEdit?.requires_training,
      description: entityToEdit?.description,
      model: entityToEdit?.model,
      is_visible_for_franchise: entityToEdit?.is_visible_for_franchise,
      is_active: entityToEdit?.is_active,
      calibration_profiles: entityToEdit.calibration_profiles,
      equipment_availabilities: entityToEdit?.equipment_availabilities
        ?.filter(item => item.is_exclusion === 0)
        .map(({ region_id, country_id, state_id }) => ({
          region_id,
          country_id,
          state_id,
        })),
      availability_exceptions: entityToEdit?.equipment_availabilities
        ?.filter(item => item.is_exclusion === 1)
        .map(({ region_id, country_id, state_id }) => ({
          region_id,
          country_id,
          state_id,
        })),
      availability_franchise_groups:
        entityToEdit?.equipment_franchise_groups?.map(item => ({
          id: item.franchise_group_id,
          name: item.franchise_name,
        })),
      equipment_serial_number: entityToEdit?.equipment_serial_number,
      equipment_date_of_purchase:
        entityToEdit?.equipment_date_of_purchase || null,
      equipment_date_of_expiry: entityToEdit?.equipment_date_of_expiry || null,
      ...getExpiryTerm(
        entityToEdit?.equipment_date_of_purchase,
        entityToEdit?.equipment_date_of_expiry,
      ),
    });
    setSelectedProfiles(entityToEdit.calibration_profiles);
  }, [entityToEdit]);

  useEffect(() => {
    setCalibrationCheckActive(!!entityToEdit.calibration_profiles);
  }, [entityToEdit.calibration_profiles]);

  const comparableMutable = JSON.stringify(mutableObject);
  const comparableInmutable = JSON.stringify(inmutableObject);
  const comparableProfiles = JSON.stringify(profiles);
  const comparableProfilesCopy = JSON.stringify(profilesCopy);

  const isEqual = useMemo(() => {
    return (
      comparableInmutable === comparableMutable &&
      comparableProfiles === comparableProfilesCopy
    );
  }, [
    mutableObject,
    inmutableObject,
    comparableProfiles,
    comparableProfilesCopy,
  ]);

  //switches states
  const handleChangeSwitch = e => {
    setMutableObject({
      ...mutableObject,
      [e.target.name]: !mutableObject[e.target.name],
    });
  };
  //selects and text states
  const handleChangeSelect = e => {
    let warrantyInformation = {};
    if (
      [
        'equipment_expiry_term_year',
        'equipment_expiry_term_month',
        'equipment_expiry_term_day',
      ].includes(e.target.name)
    ) {
      const expiryTermYear =
        e.target.name === 'equipment_expiry_term_year'
          ? e.target.value
          : mutableObject['equipment_expiry_term_year'];
      const expiryTermMonth =
        e.target.name === 'equipment_expiry_term_month'
          ? e.target.value
          : mutableObject['equipment_expiry_term_month'];
      const expiryTermDay =
        e.target.name === 'equipment_expiry_term_day'
          ? e.target.value
          : mutableObject['equipment_expiry_term_day'];
      warrantyInformation = getWarrantyInformation({
        dateOfPurchase: mutableObject['equipment_date_of_purchase'],
        dateOfExpiry: null,
        expiryTermYear,
        expiryTermMonth,
        expiryTermDay,
        expiryTerm: mutableObject['equipment_expiry_term'],
      });
    }
    setMutableObject({
      ...mutableObject,
      [e.target.name]: e.target.value,
      ...warrantyInformation,
    });
  };

  const handleChangeDateOfPurchase = date => {
    const warrantyInformation = getWarrantyInformation({
      dateOfPurchase: date
        ? parseISO(moment(date).format(formatYYYYMMDD))
        : null,
      dateOfExpiry: mutableObject['equipment_date_of_expiry'],
      expiryTermYear: mutableObject['equipment_expiry_term_year'],
      expiryTermMonth: mutableObject['equipment_expiry_term_month'],
      expiryTermDay: mutableObject['equipment_expiry_term_day'],
      expiryTerm: mutableObject['equipment_expiry_term'],
    });

    setMutableObject({
      ...mutableObject,
      ...warrantyInformation,
    });
  };

  const handleChangeExpiryDate = date => {
    const warrantyInformation = getWarrantyInformation({
      dateOfPurchase: mutableObject['equipment_date_of_purchase'],
      dateOfExpiry: date ? parseISO(moment(date).format(formatYYYYMMDD)) : null,
      expiryTermYear: mutableObject['equipment_expiry_term_year'],
      expiryTermMonth: mutableObject['equipment_expiry_term_month'],
      expiryTermDay: mutableObject['equipment_expiry_term_day'],
      expiryTerm: mutableObject['equipment_expiry_term'],
    });

    setMutableObject({
      ...mutableObject,
      ...warrantyInformation,
    });
  };

  const handleChangeAutocomplete = (name: string, value: any) => {
    //Since category_id is the only object that increases it's props when changed we validate first
    if (name === 'category_id') {
      value = {
        id: value.id,
        name: t(
          `equipment.categories.${textToSnakeCase(value?.name)}`,
          value?.name,
        ),
      };
    }
    setMutableObject({
      ...mutableObject,
      [name]: value ? value : '',
    });
  };

  const onTagsChange = (event, values) => {
    setSelectedProfiles(values);
    setMutableObject({
      ...mutableObject,
      calibration_profiles: [...values],
    });
  };

  //#region get Holding Profiles
  useEffect(() => {
    if (mutableObject) {
      if (
        !isEmptyObject(mutableObject) &&
        !isEmptyObject(mutableObject.category_id) &&
        !isEmptyObject(mutableObject.manufacturer)
      ) {
        dispatch(
          getEquipmentHoldingProfiles({
            brand: mutableObject?.brand_id,
            page: 1,
            limit: 100,
            category: mutableObject?.category_id?.id || '',
            manufacturer_id: mutableObject?.manufacturer?.id || '',
            model: mutableObject?.model || '',
            ...wrapEquipmentAvailabilities(
              groupAvailabilities(mutableObject.equipment_availabilities),
            ),
          }),
        );
      }
    }
  }, [
    mutableObject.category_id,
    mutableObject.manufacturer,
    mutableObject.model,
    availabilityAllowance,
  ]);
  //#endregion get holding Profiles

  const finalPayload = {
    id: mutableObject.id,
    brand_id: mutableObject.brand_id,
    category_id: mutableObject.category_id?.id,
    manufacturer_id: mutableObject.manufacturer?.id,
    approval_type_id: mutableObject.approval_type_id,
    is_core: mutableObject.is_core,
    is_visible_for_franchise: mutableObject.is_visible_for_franchise,
    requires_training: mutableObject.requires_training,
    description: mutableObject.description,
    model: mutableObject.model?.trim(),
    notes: '',
    ...(mutableObject.brand_id === 'TH' &&
      calibrationCheckActive && {
        calibration_profile: [...(selectedProfiles || []).map(p => p.id)],
      }),
    equipment_serial_number: mutableObject.equipment_serial_number,
    equipment_date_of_purchase:
      mutableObject.equipment_date_of_purchase || null,
    equipment_expiry_term: mutableObject.equipment_expiry_term,
    equipment_date_of_expiry: mutableObject.equipment_date_of_expiry || null,
  };

  const handleSaveEditedEquipment = async () => {
    const payload = {
      ...finalPayload,
      included_availability: ParseAvailabilityPayload(availabilityAllowance),
      ...(availabilityExclusions.length > 0 && {
        excluded_availability: ParseAvailabilityPayload(availabilityExclusions),
      }),
      ...(availabilityFranchiseGroups.length > 0 && {
        included_franchise_groups: ParseFranchiseGroupsAvailabilityPayload(
          availabilityFranchiseGroups,
        ),
      }),
      holding_profiles_allocations: profilesCopy.map(profile => profile.id),
    };
    const result: any = await dispatch(editEquipment(finalPayload.id, payload));
    if (result?.status === 200) {
      handleClose();
      onSave();
      dispatch(snackbarShowMessage('equipment.editEquipment.successMessage'));
    }
  };

  const [holdingProfilesSelected, setHoldingProfilesSelected] = useState([]);
  const onChangeMultiple = async (event, values) => {
    setHoldingProfilesSelected(values);
    const missingProfiles = values.filter(
      value => !profilesCopy.find((profile: any) => profile.id === value.id),
    );
    if (missingProfiles?.length > 0) {
      const result: any = await Promise.all(
        missingProfiles.map(profile =>
          dispatch(getEquipmentHoldingProfile('', profile.id)),
        ),
      );
      setProfilesCopy([
        ...profilesCopy.map((p: any) => p),
        ...result.map((r: any) => r.data.holdingProfile),
      ]);
    } else {
      setProfilesCopy(profiles.map(p => p));
    }
  };

  // Equipment translations
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const equipmentsTranslations = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.equipmentsTranslations,
  );

  const handleRemove = (index, id) => () => {
    const newCopyProfiles = profilesCopy.filter((p, i) => i !== index);
    const newCopySelected = holdingProfilesSelected.filter(
      (p: any) => p.id !== id,
    );
    setProfilesCopy([...newCopyProfiles]);
    setHoldingProfilesSelected([...newCopySelected]);
  };

  const handleActivateDeactivateStatus = async () => {
    const payload = {
      status: !entityToEdit.is_active ? 'Active' : 'Inactive',
    };
    const result: any = await dispatch(
      editEquipment(finalPayload.id, payload, 'patch'),
    );
    if (
      result?.status === 200 ||
      result?.status === 201 ||
      result?.status === 204
    ) {
      handleClose();
      onSave();
      dispatch(snackbarShowMessage('equipment.editEquipment.successMessage'));
      setMutableObject(prevMutableObj => ({
        ...mutableObject,
        is_active: !prevMutableObj.is_active,
      }));
    }
  };

  return (
    <div>
      <Dialog
        maxWidth="md"
        fullWidth
        open={open}
        className={classes.dialog}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <DialogTitle>
          {thisUser.hasEditEquipment ? (
            <div>{t('equipment.editEquipment')}</div>
          ) : (
            <div>{t('equipment.viewEquipment')}</div>
          )}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <RBIAutocomplete
                    onChangeInput={handleChangeAutocomplete}
                    id="category_id"
                    label={t('equipment.category')}
                    options={categories.map(option => ({
                      ...option,
                      name: t(
                        `equipment.categories.${textToSnakeCase(option.name)}`,
                        option.name,
                      ),
                    }))}
                    width={'100%'}
                    value={mutableObject['category_id']}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item xs={6}>
                  <RBIAutocomplete
                    disabled={readOnly}
                    onChangeInput={handleChangeAutocomplete}
                    value={mutableObject['manufacturer']}
                    id="manufacturer"
                    label={t('equipment.manufacturer')}
                    options={manufacturers}
                    width={'100%'}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    size="small"
                    variant="outlined"
                    label={t('equipment.model')}
                    fullWidth
                    value={mutableObject?.model}
                    name="model"
                    disabled={readOnly}
                    onChange={handleChangeSelect}
                    autoFocus={false}
                  />
                </Grid>
                <Grid item xs={entityToEdit.brand === 'TH' ? 6 : 3}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      className={classes.selectLabel}
                    >
                      {t('equipment.editEquipment.approvalType')}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      disabled={readOnly}
                      id="demo-simple-select-outlined"
                      label={t('equipment.editEquipment.approvalType')}
                      className={classes.selectCategory}
                      fullWidth
                      name="approval_type_id"
                      onChange={handleChangeSelect}
                      value={mutableObject?.approval_type_id}
                    >
                      {approvalTypes.map(type => (
                        <MenuItem key={type.id} value={type.id}>
                          {t(
                            `equipment.approval.type.${textToSnakeCase(
                              type?.name,
                            )}`,
                            type.name,
                          )}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <Grid container spacing={0} style={{ marginLeft: -10 }}>
                    {entityToEdit.brand !== 'TH' && (
                      <React.Fragment>
                        <Grid container spacing={0}>
                          <Hidden smDown>
                            <Grid item md lg xl>
                              <Typography
                                variant="caption"
                                style={{ float: 'right', marginRight: 4 }}
                              >
                                {t('equipment.nonCore')}
                              </Typography>
                            </Grid>
                          </Hidden>
                          <Grid item>
                            <div style={{ marginTop: 2 }}>
                              <AntSwitch
                                disabled={readOnly}
                                checked={mutableObject?.is_core}
                                name="is_core"
                                onChange={handleChangeSwitch}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              variant="caption"
                              style={{ float: 'left', marginLeft: 4 }}
                            >
                              {t('equipment.core')}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                          <Hidden smDown>
                            <Grid item md lg xl>
                              <Typography
                                variant="caption"
                                style={{ float: 'right', marginRight: 4 }}
                              >
                                {t('equipment.nonVisible')}
                              </Typography>
                            </Grid>
                          </Hidden>
                          <Grid item>
                            <div style={{ marginTop: 2 }}>
                              <AntSwitch
                                checked={
                                  mutableObject?.is_visible_for_franchise
                                }
                                name="is_visible_for_franchise"
                                disabled={readOnly}
                                onChange={handleChangeSwitch}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              variant="caption"
                              style={{ float: 'left', marginLeft: 4 }}
                            >
                              {t('equipment.visible')}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={0}>
                          <Hidden smDown>
                            <Grid item md lg xl>
                              <Typography
                                variant="caption"
                                style={{ float: 'right', marginRight: 4 }}
                              >
                                {t('equipment.noTraining')}
                              </Typography>
                            </Grid>
                          </Hidden>
                          <Grid item>
                            <div style={{ marginTop: 2 }}>
                              <AntSwitch
                                disabled={readOnly}
                                checked={mutableObject?.requires_training}
                                name="requires_training"
                                onChange={handleChangeSwitch}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              variant="caption"
                              style={{ float: 'left', marginLeft: 4 }}
                            >
                              {t('equipment.training')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    variant="outlined"
                    label={t('equipment.editEquipment.description')}
                    fullWidth
                    name="description"
                    onChange={handleChangeSelect}
                    disabled={readOnly}
                    value={mutableObject?.description}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    style={{ width: '100%', marginTop: 8 }}
                    size="small"
                    onChange={handleChangeSelect}
                    value={mutableObject['equipment_serial_number']}
                    name="equipment_serial_number"
                    variant="outlined"
                    label={t('createModel.SerialNumber')}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item xs={6}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localesMap[selectedLanguage || 'eng']}
                  >
                    <DatePicker
                      style={{ width: '100%', margin: '8px 8px 8px 0px' }}
                      size="small"
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      id={`equipment_date_of_purchase`}
                      label={t('createModel.DateOfPurchase')}
                      format="yyyy-MM-dd"
                      clearable
                      disableFuture
                      name={`equipment_date_of_purchase`}
                      value={formatDate(
                        mutableObject['equipment_date_of_purchase'],
                      )}
                      onChange={handleChangeDateOfPurchase}
                      disabled={readOnly}
                      error={
                        !isPurchaseDateBeforeExpiryDate(
                          mutableObject['equipment_date_of_purchase'],
                          mutableObject['equipment_date_of_expiry'],
                        )
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12}>
                  <Box component="fieldset">
                    <FormLabel component="legend">
                      {t('createModel.ExpiryTerm')}
                    </FormLabel>
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                      <TextField
                        style={{ width: '100%', marginTop: 8 }}
                        size="small"
                        onChange={handleChangeSelect}
                        value={mutableObject['equipment_expiry_term_year']}
                        name="equipment_expiry_term_year"
                        variant="outlined"
                        label={t('createModel.Year')}
                        disabled={readOnly}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        InputLabelProps={{
                          shrink:
                            mutableObject['equipment_expiry_term_year'] !==
                            null,
                        }}
                      />
                      <TextField
                        style={{ width: '100%', marginTop: 8 }}
                        size="small"
                        onChange={handleChangeSelect}
                        value={mutableObject['equipment_expiry_term_month']}
                        name="equipment_expiry_term_month"
                        variant="outlined"
                        label={t('createModel.Month')}
                        disabled={readOnly}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        InputLabelProps={{
                          shrink:
                            mutableObject['equipment_expiry_term_month'] !==
                            null,
                        }}
                      />
                      <TextField
                        style={{ width: '100%', marginTop: 8 }}
                        size="small"
                        onChange={handleChangeSelect}
                        value={mutableObject['equipment_expiry_term_day']}
                        name="equipment_expiry_term_day"
                        variant="outlined"
                        label={t('createModel.Day')}
                        disabled={readOnly}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        InputLabelProps={{
                          shrink:
                            mutableObject['equipment_expiry_term_day'] !== null,
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localesMap[selectedLanguage || 'eng']}
                  >
                    <DatePicker
                      style={{ width: '100%', margin: '8px 8px 8px 0px' }}
                      size="small"
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      id={`equipment_date_of_expiry`}
                      label={t('createModel.DateOfExpiry')}
                      format="yyyy-MM-dd"
                      clearable
                      name={`equipment_date_of_expiry`}
                      value={formatDate(
                        mutableObject['equipment_date_of_expiry'],
                      )}
                      onChange={handleChangeExpiryDate}
                      disabled={readOnly}
                      error={
                        !isPurchaseDateBeforeExpiryDate(
                          mutableObject['equipment_date_of_purchase'],
                          mutableObject['equipment_date_of_expiry'],
                        )
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Grid>

                {mutableObject.brand_id === 'TH' && (
                  <Grid container>
                    <Grid item sm={6}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Grid container style={{ alignItems: 'center' }}>
                            <Grid
                              item
                              xs={5}
                              style={{ textAlign: 'right', marginRight: 4 }}
                            >
                              <Typography variant="caption" color="initial">
                                {t('equipment.nonCore')}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <AntSwitch
                                checked={mutableObject?.is_core}
                                name={`is_core`}
                                disabled={readOnly}
                                onChange={handleChangeSwitch}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              style={{ textAlign: 'left', marginLeft: 4 }}
                            >
                              <Typography variant="caption" color="initial">
                                {t('equipment.core')}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item sm={12}>
                          <Grid container style={{ alignItems: 'center' }}>
                            <Grid
                              item
                              xs={5}
                              style={{ textAlign: 'right', marginRight: 4 }}
                            >
                              <Typography variant="caption" color="initial">
                                {t('equipment.nonVisible')}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <AntSwitch
                                checked={
                                  mutableObject?.is_visible_for_franchise
                                }
                                name={`is_visible_for_franchise`}
                                disabled={readOnly}
                                onChange={handleChangeSwitch}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              style={{ textAlign: 'left', marginLeft: 4 }}
                            >
                              <Typography variant="caption" color="initial">
                                {t('equipment.visible')}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Grid container style={{ alignItems: 'center' }}>
                            <Grid
                              item
                              xs={5}
                              style={{ textAlign: 'right', marginRight: 4 }}
                            >
                              <Typography variant="caption" color="initial">
                                {t('equipment.noTraining')}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <AntSwitch
                                disabled={readOnly}
                                checked={mutableObject?.requires_training}
                                name="requires_training"
                                onChange={handleChangeSwitch}
                              />
                            </Grid>
                            <Grid item xs={4} style={{ textAlign: 'left' }}>
                              <Typography variant="caption" color="initial">
                                {t('equipment.training')}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container style={{ alignItems: 'center' }}>
                          <Grid
                            item
                            xs={5}
                            style={{ textAlign: 'right', marginRight: 4 }}
                          >
                            <Typography variant="caption" color="initial">
                              {t('equipment.noCalibration')}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <AntSwitch
                              checked={calibrationCheckActive}
                              disabled={readOnly}
                              onChange={handleCalibrationFieldActivation}
                            />
                          </Grid>
                          <Grid item xs={4} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" color="initial">
                              {t('equipment.calibration')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/*DropDwown multiselect only for th chip multiselect*/}
                {entityToEdit.brand === 'TH' && calibrationCheckActive && (
                  <Grid item xs={12} lg={12} xl={12} sm={12} md={12}>
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={cProfiles}
                      noOptionsText={t`app.common.noOptions`}
                      onChange={onTagsChange}
                      getOptionLabel={(profile: any) => profile.name || ''}
                      defaultValue={mutableObject['calibration_profiles']}
                      filterSelectedOptions
                      disabled={readOnly}
                      renderInput={params => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={t(
                            'equipment.editEquipment.calibrationProfiles',
                          )}
                          placeholder="Select Profiles"
                        />
                      )}
                    />
                  </Grid>
                )}
                {/* aqui acaba el chip multiselect para holding profiles*/}

                <Grid item xs={12}>
                  <EquipmentAvailabilitySelector
                    allowance={availabilityAllowance}
                    exclusions={availabilityExclusions}
                    hasExclusions={true}
                    disabled={readOnly}
                    onAllowanceChange={handleAvailabilityAllowanceChange}
                    onExclusionsChange={handleAvailabilityExclusionsChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <EquipmentFranchiseGroupsSelector
                    id="franchise-groups-availability-input"
                    label={t('equipment.franchiseGroups')}
                    brand={entityToEdit.brand}
                    disabled={readOnly}
                    value={availabilityFranchiseGroups}
                    onChange={handleFranchiseGroupsChange}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.translationsContainer}>
                <div className={classes.containerAppBar}>
                  <Typography className={classes.containerTitle}>
                    {t('app.common.translations')} (
                    {
                      equipmentsTranslations?.filter(e => e.value !== null)
                        .length
                    }
                    )
                  </Typography>
                  {thisUser.hasCreateTranslationsMultilanguage && (
                    <IconButton
                      className={classes.containerTitleButton}
                      onClick={showEquipmentTranslation(entityToEdit.id)}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </div>
                {equipmentsTranslations?.map(translation =>
                  translation.value === null ? (
                    ''
                  ) : (
                    <div key={translation.language.id}>
                      <DividerWithText mt={10}>
                        {translation.language.name?.toString()}
                      </DividerWithText>
                      <Typography className={classes.translationItem}>
                        {translation.value}
                      </Typography>{' '}
                    </div>
                  ),
                )}
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <div className={classes.holdingProfilesContainer}>
                <div
                  className={`${classes.containerAppBar} ${classes.flexSpaceBetween}`}
                >
                  <Typography className={classes.containerTitle}>
                    {t('equipment.holdingProfiles')}
                  </Typography>

                  <Autocomplete
                    multiple
                    className={classes.addToCatalogAutocomplete}
                    id="tags-outlined"
                    disabled={readOnly}
                    options={holdingProfilesToAdd.holdingProfiles || []}
                    defaultValue={holdingProfilesSelected}
                    noOptionsText={t`app.common.noOptions`}
                    filterSelectedOptions
                    onChange={onChangeMultiple}
                    getOptionLabel={(p: any) =>
                      `(${t(
                        `equipment.categories.${textToSnakeCase(
                          p.category?.name,
                        )}`,
                        p.category.name,
                      )},${p.manufacturer.name})${p.availabilities[0]?.region}`
                    }
                    // filterSelectedOptions
                    size="small"
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label={t('equipment.addFromCatalog')}
                        size="small"
                        margin="none"
                        className={classes.addToCatalog}
                      />
                    )}
                  />
                </div>
                <div className={classes.holdingProfilesTabs}>
                  <VerticalTabsEquipmentAssigned
                    profiles={profilesCopy}
                    value={tabValue}
                    setValue={setTabValue}
                    defaultName={t('equipment.holdingProfile')}
                  />
                  {profilesCopy.map((profile, index) => (
                    <TabPanel
                      key={`Tab_${index}`}
                      value={tabValue}
                      index={index}
                    >
                      <ShowHoldingProfileEquipment
                        title={t(
                          'productGroups.viewDetail.productProfileAvailability',
                        )}
                        readOnly={readOnly}
                        holdingProfile={profile}
                        handleRemove={handleRemove}
                        index={index}
                      />
                    </TabPanel>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          className={classes.dialogActionsWrapper}
          style={{
            justifyContent: thisUser.hasCreateEquipment
              ? 'space-between'
              : 'flex-end',
          }}
        >
          <Fragment>
            {thisUser.hasCreateEquipment && (
              <div className={classes.activeBtnWrapper}>
                <Button
                  variant="outlined"
                  onClick={handleActivateDeactivateStatus}
                >
                  {t(
                    `equipment.editEquipment.${
                      mutableObject?.is_active
                        ? 'inactiveBtnText'
                        : 'activeBtnText'
                    }`,
                  )}
                </Button>
              </div>
            )}
            {thisUser.hasEditEquipment ? (
              <div>
                <Button
                  disabled={isEqual}
                  variant="outlined"
                  onClick={handleClose}
                  className={classes.dialogBtn}
                >
                  {t('app.common.cancel')}
                </Button>
                <Button
                  disabled={
                    readOnly ||
                    mutableObject?.model?.length === 0 ||
                    !mutableObject['manufacturer'] ||
                    !mutableObject['category_id'] ||
                    !mutableObject['approval_type_id'] ||
                    mutableObject?.description?.length === 0 ||
                    availabilityAllowance.length === 0 ||
                    isEqual ||
                    (selectedBrand === 'TH' &&
                      calibrationCheckActive &&
                      !selectedProfiles?.length)
                  }
                  onClick={handleSaveEditedEquipment}
                  variant="outlined"
                  className={classes.dialogBtn}
                >
                  {t('app.common.save')}
                </Button>
              </div>
            ) : (
              <Button variant="outlined" onClick={handleClose}>
                {t('app.common.close')}
              </Button>
            )}
          </Fragment>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditEquipmentModal;
